module.exports = __webpack_public_path__ + "media/new-message-sound.dc2bcf44.ogg";